module.exports = __webpack_public_path__ + "static/media/ic-completed.50451873.svg";